/*
 * Copyright (C) 2026 to Present Applause App Quality, Inc. All rights reserved.
 */

import {
  AfterViewInit, Directive, ElementRef, OnDestroy,
} from '@angular/core';

// Makes a scrolling list keyboard-reachable only while it overflows, so a short list isn't an empty tab stop.
@Directive({ selector: '[utScrollFocus]', standalone: true })
export class ScrollFocusDirective implements AfterViewInit, OnDestroy {
  private observer: ResizeObserver | undefined;

  constructor(private el: ElementRef<HTMLElement>) {}

  ngAfterViewInit(): void {
    const list = this.el.nativeElement;
    const update = () => {
      if (list.scrollHeight > list.clientHeight) list.setAttribute('tabindex', '0');
      else list.removeAttribute('tabindex');
    };
    update();
    // The list fills in after the first render, and its rows change height with the card width.
    this.observer = new ResizeObserver(update);
    this.observer.observe(list);
    Array.from(list.children).forEach((row) => this.observer.observe(row));
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
  }
}
